export default __webpack_public_path__ + "static/media/1resize.bdb5f0a4.jpg";